import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';

// D7 — 消す・まとめて動かす操作は、必ず一度確認してから実行する。
// 取り返しのつかない操作（フォルダーの削除）は名前を打ってもらう。
export default function ConfirmDialog({
  open, title, message, confirmLabel = '実行', tone = 'default',
  requireText, extra, disabled = false, onCancel, onConfirm, testid = 'confirm',
}) {
  const [typed, setTyped] = useState('');
  const blocked = disabled || (!!requireText && typed.trim() !== requireText);
  if (!open) return null;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) { setTyped(''); onCancel?.(); } }}>
      <DialogContent className="max-w-md" data-testid={`${testid}-dialog`}>
        <DialogHeader><DialogTitle className="text-base">{title || '確認'}</DialogTitle></DialogHeader>
        <DialogDescription className="text-sm text-zinc-600 whitespace-pre-line" data-testid={`${testid}-message`}>{message}</DialogDescription>
        {extra}
        {requireText && (
          <div className="mt-1">
            <p className="text-xs text-zinc-500 mb-1">
              確認のため「<span className="font-semibold text-zinc-700">{requireText}</span>」と入力してください
            </p>
            <Input value={typed} onChange={(e) => setTyped(e.target.value)} className="h-9"
              data-testid={`${testid}-text`} />
          </div>
        )}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => { setTyped(''); onCancel?.(); }}
            data-testid={`${testid}-cancel`}>キャンセル</Button>
          <Button disabled={blocked} data-testid={`${testid}-ok`}
            className={tone === 'danger' ? 'bg-rose-600 hover:bg-rose-700' : 'bg-teal-700 hover:bg-teal-800'}
            onClick={() => { setTyped(''); onConfirm?.(); }}>{confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
